import { useParams } from 'react-router-dom'
import { FormEditor } from 'app/components/paperwork/FormEditor'
import { useFormEditor } from 'app/components/paperwork/useFormEditor'

function FormEditorRoute({ id }: { id: string }) {
  const props = useFormEditor(id)
  return <FormEditor {...props} />
}

export default function SettingsFormEditor() {
  const { formTemplateId = `` } = useParams()
  // Keyed so opening another version starts from that version's own saved state.
  return <FormEditorRoute key={formTemplateId} id={formTemplateId} />
}
